/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsSpacing, ExdsText} from "@exds/core";
import {ExdsIconHistory} from "@exds/icons";

export default function AfterSubmitCheck(props) {
  const {check, key} = props;

  return (
    <div className="mt-1" key={key}>
      <ExdsSpacing margin={{top: '10px'}} >
        <ExdsIconHistory aria-hidden color="regular" size="small" aria-label="After Submit Check"/>
        <ExdsText
          textStyle="bodyMedium"
          className="req-text fw-600"
        >
          {check}
        </ExdsText>
      </ExdsSpacing>
    </div>
  );
};
